export interface IUserCulture {
  DateFormat: string;
  DateTimeFormat: string;
  TimeFormat: string;
  UserCulture: string;
  CurrencySymbol: string;
  ISOCurrencySymbol: string;
  NumberGroupSeparator: string;
  NumberDecimalSeparator: string;
}

/**
 * A module (which is treated as a singleton) for user culture settings, which come from the server;
 * For testing, etc. this is defaulted to US culture values
 */
let UserCulture: IUserCulture = {
  DateFormat: 'M/d/yyyy',
  DateTimeFormat: 'M/d/yyyy H:mm:ss',
  TimeFormat: 'H:mm:ss',
  UserCulture: 'en-US',
  CurrencySymbol: '$',
  ISOCurrencySymbol: 'USD',
  NumberGroupSeparator: ',',
  NumberDecimalSeparator: '.',
};

export function setUserCulture(culture: IUserCulture) {
  UserCulture = culture;
}

export function getUserCulture() {
  return UserCulture;
}

if (DEV_SERVER) {
  // use require to avoid importing this into production bundles
  const mocks = require('./__mocks__/UserCultureMocks.ts').UserCultureMocks;
  // DEBUG German:

  UserCulture = mocks.deDE;
}
